import React from "react";
import ReporteVentas from "../components/ReporteVentas";

const InformeVentas = () => {
  return (
    <>
      <ReporteVentas />
    </>
  );
};

export default InformeVentas;